<template>
  <v-menu offset-y>
    <v-btn slot="activator" class="hidden-sm-and-down ma-2" tile outlined color="primary">
      {{fullname}}
      <v-icon>mdi-chevron-down</v-icon>
    </v-btn>
    <v-list>
      <v-list-tile>
        <v-list-tile-title>
          <router-link :to="{name:'missings.create'}">
            <span>بلاغ جديد</span>
          </router-link>
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-title>
          <router-link :to="{name:'missings.usermissings'}">
            <span>بلاغاتي</span>
          </router-link>
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  props: {
    fullname: {
      type: String
    }
  }
};
</script>
<style scoped>
</style>


